import { readLiveSensorsAnonymousId } from '../utils/sensorsIdentity';

import { sensorsReadiness as readiness, hasSensorsInitialized } from './sensorsReadiness';
export { markSensorsInitialized, hasSensorsInitialized } from './sensorsReadiness';

/** 只接受本窗口已初始化 Sensors 的实时匿名ID，不使用缓存或_fpid。 */
export function isSensorsIdentityReady(): boolean {
  if (!hasSensorsInitialized()) return false;
  if (!readLiveSensorsAnonymousId()) return false;
  readiness.get(window)!.established = true;
  return true;
}

/** 后续reset或身份丢失不得重新取得首次身份补齐资格。 */
export function getSensorsIdentityPhase(): 'initial' | 'established' {
  return typeof window !== 'undefined' && readiness.get(window)?.established
    ? 'established'
    : 'initial';
}
